import React, { ReactNode, SyntheticEvent } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { HorizontalStrip, VerticalStrip } from '@r1-frontend/ui-react/components/Modal/Strip';
import { TSvgProps } from '@r1-frontend/ui-react/components/svg/createSvg';
import { Close } from '@r1-frontend/ui-react/components/svg/main';
import { TRadius } from '@r1-frontend/ui-react/experimental/containers/RounderContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export type TSheetPosition = |
    'top' |
    'right' |
    'bottom' |
    'left';

export type TSheetProps = {
    children: ReactNode | string,
    position?: TSheetPosition,
    onStripClick?: () => void,
    onIconClick?: (e: SyntheticEvent) => void,
    Icon?: (props: TSvgProps) => JSX.Element,

    $radius?: TRadius,
    $bgColor?: COLORS,
}

const Sheet = ({
    children,
    position = 'bottom',
    onStripClick,
    onIconClick = () => true,
    Icon = Close,
    ...props
}: TSheetProps): JSX.Element => {
    const StripComponent = position === 'top' || position === 'bottom' ? HorizontalStrip : VerticalStrip;

    return <div {...props} data-test={`Sheet Sheet__position[${position}]`}>
        {/* Typescript could not satisfy types of StripComponent */}
        {/* @ts-ignore */}
        <StripComponent $position={position} onClick={onStripClick}/>

        {Icon && (
            <Button
                bType={'secondary'}
                rounded
                size={'small'}
                onClick={onIconClick}
                Icon={<Icon size={20}/>}
            />
        )}

        {children}
    </div>;
};

export default Sheet;
